module.exports = __webpack_public_path__ + "fonts/Flaticon2.b242ac81.woff";